import ContentWrapper from "@/components/wrappers/ContentWrapper";
import { useFilterSearchParams } from "@/utils/hooksUtils";
import { COMMON_AGENT_FILTER_SEARCH_PARAMS, DEFAULT_FILTER_AGENT_COMPETENCES_QUERY_PARAMS } from "../api";
import AgentEndingCompetenceFilterForm from "../components/forms/AgentEndingCompetenceFilterForm";
import { AgentEndingCompetenceTable } from "../components/tables/AgentEndingCompetenceTable";
import { AgentCompetenceFilterPageRequest } from "../types";

export const AgentEndingCompetenceContainer = () => {
  const searchParams = useFilterSearchParams<AgentCompetenceFilterPageRequest>({
    params: ["types", "levels", "providers", "sectors", ...COMMON_AGENT_FILTER_SEARCH_PARAMS],
    defaultQueryParamsObject: DEFAULT_FILTER_AGENT_COMPETENCES_QUERY_PARAMS,
  });

  return (
    <ContentWrapper>
      <AgentEndingCompetenceFilterForm searchParams={searchParams} />
      <AgentEndingCompetenceTable searchParams={searchParams} />
    </ContentWrapper>
  );
};
